<div class="transfer-body flexRow border-1 defaultRadius align-items-stretch">
  <div class="show-options-box" style="width:{{ leftWidth }}">
    <div class="box-title">
      <nz-tabset [nzTabBarStyle]="{ padding: '0 16px' }">
        <nz-tab [nzTitle]="tabTitleTpl_1">
          <ng-template #tabTitleTpl_1>
            <div class="tab-item">标签模板</div>
          </ng-template>
          <div class="tpl-list-box scroll">
            <ng-container *ngFor="let tpl of data['group']; let i = index">
              <div
                class="tpl-item pl-sm clickEle d-flex justify-content-between align-items-center"
                (click)="selectTpl(tpl)"
                [ngClass]="{ selectOption: tpl['value'] == selectTplData['value'] }"
              >
                <span>{{ tpl['label'] }}</span>
                <i nz-icon nzType="delete" nzTheme="outline" class="mr-md" (click)="delTpl(tpl, i, $event)"></i>
              </div>
            </ng-container>
          </div>
        </nz-tab>
        <nz-tab [nzTitle]="tabTitleTpl_2">
          <ng-template #tabTitleTpl_2>
            <div class="tab-item">历史标签</div>
          </ng-template>
          <div class="tpl-list-box scroll">
            <ng-container *ngFor="let item of data['list']">
              <div
                class="tpl-item pl-sm clickEle"
                (click)="selectItem(item)"
                [ngClass]="{ selectOption: selectLabelData.indexOf(item) > -1 }"
              >
                {{ item }}
              </div>
            </ng-container>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
  <div class="select-options-box flexFull border-left-1 flexColumn">
    <div class="box-title flexRow pl-sm pr-sm">
      <div class="mr-xs">已选</div>
      <div class="selectCount pl-sm text-gray1">({{ addLabelData.length + selectLabelData.length }}项)</div>
      <div class="flexFull select-result-box borde-bottom-1"></div>
      <div class="clickEle text-primary" (click)="clear()">清空</div>
    </div>
    <div class="flexFull border-bottom-1 select-result-box flexColumn">
      <div class="search-box p-sm">
        <nz-input-group [nzSuffix]="add_button" class="pt0 pb0 pr0">
          <input
            nz-input
            [(ngModel)]="addLabelContent"
            class="search-input"
            placeholder="最多20个标签, 每个标签不超过10个字, 可用空格分隔"
            (keydown.enter)="addLabel()"
            maxlength="10"
          />
          <ng-template #add_button>
            <div class="add-button text-center clickEle" (click)="addLabel()">添加</div>
          </ng-template>
        </nz-input-group>
      </div>
      <div class="flexRow pl-sm pr-sm label-box pt-sm align-items-start flex-wrap scroll" style="overflow-y: auto">
        <ng-container *ngFor="let selectLabel of selectLabelData; let index = index">
          <div class="flexRow label-item border-1 defaultRadius pl-sm pr-sm form-card-disable mr-sm mb-sm">
            <div class="ml-xs mr-xs">{{ selectLabel }}</div>
            <i
              nz-icon
              nzType="close-circle"
              nzTheme="outline"
              class="ml-sm mr-xs text-gray2 clickEle"
              (click)="delLabel('select', index)"
            ></i>
          </div>
        </ng-container>
        <ng-container *ngFor="let addLabel of addLabelData; let index = index">
          <div class="flexRow label-item border-1 defaultRadius pl-sm pr-sm form-card-disable mr-sm mb-sm">
            <div class="ml-xs mr-xs">{{ addLabel }}</div>
            <i nz-icon nzType="close-circle" nzTheme="outline" class="ml-sm mr-xs text-gray2 clickEle" (click)="delLabel('add', index)"></i>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="save-box flexRow text-right pr-sm">
      <div class="flexFull"></div>
      <button nz-button class="mr-xs" nzType="default" (click)="saveTpl()">保存为模板</button>
    </div>
  </div>
</div>
